/* eslint-disable */
<template>
  <div class="building">
    <Tooltip :visible="tooltip.active">
      <component
        :is="tooltip.is"
        :active="tooltip.active"
        :flat="tooltip.data"
        :floor="tooltip.data"
        :building="tooltip.building || currentBuilding.name"
      ></component>
    </Tooltip>
    <div class="spritespin">
      <transition name="fade">
        <Loader
          v-if="!loaded"
          :spinner="true"
          :text="$t('singleBuilding.loading')"
          :zIndex="150"
        ></Loader>
      </transition>
      <Windrose
        class="spritespin__compass"
        :rotation="windroseRotation"
      ></Windrose>

      <div id="spritespin" ref="spritespin" class="spritespin__content"></div>
      <div class="spritespin__map" ref="map" @click="onMapClick">
        <transition name="fade">
          <component
            v-if="loaded"
            :is="maps[currentBreakpoint]"
            @changed="onMapChange"
          />
        </transition>
        <template v-if="points">
          <div
            v-for="point in points[currentBreakpoint]"
            :key="point.name"
            :class="
              `spritespin__point ${
                !isRunning ? 'spritespin__point--visible' : ''
              }`
            "
            :style="{
              top: `${point.Y}`,
              left: `${point.X}`,
              transform: `translate(-${point.X}, -${point.Y})`,
            }"
          >
            <div class="spritespin__point-inner">
              <span>+</span>
              <div
                :class="`spritespin__point-label ${point.labelDirection || ''}`"
              >
                <span>{{ point.name }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <button @click="prevFunc" class="spritespin__button--left">
        <img src="@/assets/arrow-left.svg" alt="strzałka w lewo" />
      </button>
      <button @click="nextFunc" class="spritespin__button--right">
        <img src="@/assets/arrow-right.svg" alt="strzałka w prawo" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// import * as SpriteSpin from "spritespin";
import { validateBuilding } from '@/plugins/routeValidator';
// Components
import Loader from '@/components/loader.vue';
import flatTooltip from '@/components/flat/flat-tooltip.vue';
import floorTooltip from '@/components/floor/floor-tooltip.vue';
import Tooltip from '@/components/tooltip.vue';
import Windrose from '@/components/windrose.vue';
export default {
  name: 'Building',
  data() {
    return {
      currentBreakpoint: 0,
      spritespin: null,
      isRunning: false,
      loaded: false,
      isDragging: false,
      time: 'day',
      windroseRotation: 0,
      path: null,
      tooltip: {
        active: false,
        data: {},
        is: flatTooltip,
      },
    };
  },
  components: { Loader, Windrose, Tooltip },
  computed: {
    ...mapState({
      filters: state => state.browser.filters,
      constantFilters: state => state.browser.constantFilter,
      flatProperties: state => state.browser.flatProperties,
    }),
    ...mapGetters({
      multiBuilding: 'IS_MULTI_BUILDING',
      currentBuilding: 'GET_INVESTMENT_CURRENT_BUILDING',
      currentInvestmentURL: 'GET_INVESTMENT_URL',
      flats: 'GET_FLATS',
      filteredFlats: 'GET_FILTERED_FLATS',
    }),
    spinInfo() {
      return this.currentBuilding.spritespin;
    },
    sense() {
      return this.spinInfo.sense;
    },
    frameTime() {
      return this.spinInfo.frameTime;
    },
    framesURL() {
      return this.spinInfo.framesURL[this.time];
    },
    breakpoints() {
      return this.spinInfo.breakpoints;
    },
    maps() {
      return this.spinInfo.maps;
    },
    windroseInitialRotation() {
      return this.spinInfo.windroseInitialRotation;
    },
    frames() {
      return this.spinInfo.frames;
    },
    framesPerRow() {
      return this.spinInfo.framesPerRow;
    },
    points() {
      return this.spinInfo.points;
    },
    filteredFloors() {
      let floors = this.filteredFlats.map(flat =>
        Number(flat[this.flatProperties['floor']])
      );
      return [...new Set(floors)];
    },
    filteredFlatsNumbers() {
      return [
        ...this.filteredFlats.map(flat =>
          flat[this.flatProperties['id']].toLowerCase()
        ),
      ];
    },
    prevFunc() {
      return this.sense == -1 ? this.next : this.prev;
    },
    nextFunc() {
      return this.sense == -1 ? this.prev : this.next;
    },
  },
  watch: {
    flats() {
      this.initMap();
    },
    filters() {
      this.initMap();
    },
    constantFilters() {
      this.initMap();
    },
    $route(route) {
      if (route.name == '3d') {
        this.tooltip.active = false;
      }
    },
  },
  methods: {
    next() {
      this.isRunning = true;
      if (this.spritespin) {
        this.spritespin.reverse = true;
      }
      this.currentBreakpoint =
        (this.breakpoints.length + this.currentBreakpoint - 1) %
        this.breakpoints.length;
      $('#spritespin')
        .spritespin('api')
        .playTo(this.breakpoints[this.currentBreakpoint], true);
    },
    prev() {
      this.isRunning = true;
      if (this.spritespin) {
        this.spritespin.reverse = false;
      }
      this.currentBreakpoint =
        (this.currentBreakpoint + 1) % this.breakpoints.length;
      $('#spritespin')
        .spritespin('api')
        .playTo(this.breakpoints[this.currentBreakpoint], true);
    },
    switchTime(time) {
      this.time = time || (this.time == 'day' ? 'night' : 'day');
      this.loaded = false;
      this.progress = 0;
      this.loadSpriteSpin();
    },
    loadSpriteSpin() {
      this.spritespin = $('#spritespin')
        .spritespin({
          source: this.framesURL,
          frames: this.frames,
          frameTime: this.frameTime,
          framesX: this.framesPerRow,
          animate: false,
          renderer: 'canvas',
          sense: this.sense,
          plugins: ['360', 'drag'],
          onInit: () => {
            this.initMap();
          },
          onComplete: () => {
            this.setAspectRatio();
            this.loaded = true;
            this.initMap();
          },
          onFrame: () => {
            // Hiding tooltip
            this.tooltip.active = false;
            // Checking for rotation
            this.isRunning = !this.breakpoints.includes(this.spritespin.frame);
            // Setting current breakpoint
            if (this.breakpoints.includes(this.spritespin.frame)) {
              this.currentBreakpoint = this.breakpoints.indexOf(
                this.spritespin.frame
              );
            }
            // Windrose
            let value =
              (this.spritespin.frame / this.spritespin.frames) * 360 +
              this.windroseInitialRotation;
            this.rotateWindrose(value);
          },
        })
        .data('spritespin');
    },
    setAspectRatio() {
      let ratio = this.spritespin.frameWidth / this.spritespin.frameHeight;
      if (
        document.documentElement.clientHeight * ratio >=
        document.documentElement.clientWidth
      ) {
        this.$refs.spritespin.style.width = `calc(100vh * ${ratio})`;
        this.$refs.spritespin.style.height = `100vh`;
        this.$refs.map.style.width = `calc(100vh * ${ratio})`;
        this.$refs.map.style.height = `100vh`;
      } else {
        this.$refs.spritespin.style.width = `100vw`;
        this.$refs.spritespin.style.height = `calc(100vw / ${ratio})`;
        this.$refs.map.style.width = `100vw`;
        this.$refs.map.style.height = `calc(100vw / ${ratio})`;
      }
    },
    rotateWindrose(deg) {
      this.windroseRotation = deg;
    },
    findNearestBreakpoint() {
      if (this.spritespin) {
        let { frame } = this.spritespin;
        let breakpoint = 0;
        let minDistance = Math.abs(this.breakpoints[0] - frame);
        for (let index in this.breakpoints) {
          let distance = Math.abs(this.breakpoints[index] - frame);
          if (distance < minDistance) {
            minDistance = distance;
            breakpoint = index;
          }
        }
        return breakpoint;
      }
    },
    onDragEnd() {
      this.isDragging = false;
      if (this.$route.name == 'building' && this.path == this.$route.path) {
        let nearest = this.findNearestBreakpoint();
        if (this.breakpoints[nearest] - this.spritespin.frame < 0) {
          this.spritespin.reverse = true;
        } else {
          this.spritespin.reverse = false;
        }
        $('#spritespin')
          .spritespin('api')
          .playTo(this.breakpoints[nearest], true);
      }
    },
    onDragging() {
      this.isDragging = true;
    },
    onMapClick(event) {
      if (event.target.parentElement.nodeName == 'svg') {
        let floor = $(event.target).data('floor');
        let flat = $(event.target).data('flat');
        let building = $(event.target).data('building');
        if (building != null && floor != null) {
          this.enterFloor(floor, building);
        } else if (floor != null) {
          this.enterFloor(floor);
        } else if (flat != null) {
          this.enterFlat(flat.toLowerCase());
        }
      }
    },
    enterFloor(floor, building) {
      if (building != null) {
        this.$router.push({
          path: `/${this.currentInvestmentURL}/building/${building}/floor/${floor}`,
          query: { filters: this.$route.query.filters },
        });
      } else {
        this.$router.push({
          path: `/${this.currentInvestmentURL}/building/${this.$route.params.building}/floor/${floor}`,
          query: { filters: this.$route.query.filters },
        });
      }
    },
    enterFlat(flat) {
      this.$router.push({
        path: `/${this.currentInvestmentURL}/flat/${flat.toUpperCase()}`,
      });
    },
    getFlatById(id) {
      for (let flat of this.flats) {
        if (flat[this.flatProperties['id']].toUpperCase() == id.toUpperCase()) {
          return flat;
        }
      }
    },
    applyFloorEvents(floor, number) {
      $(floor).mouseenter(e => {
        if ($(e.target).hasClass('active') && !this.isDragging) {
          let building = $(event.target).data('building');
          if (building != null) {
            this.tooltip.building = building;
          } else {
            this.tooltip.building = null;
          }
          this.tooltip.active = true;
          this.tooltip.data = number;
          this.tooltip.is = floorTooltip;
          $(e.target).addClass('hover');
        }
      });
      $(floor).mouseleave(e => {
        if ($(e.target).hasClass('active')) {
          this.tooltip.active = false;
          $(e.target).removeClass('hover');
        }
      });
    },
    applyFlatEvents(flat, number) {
      $(flat).mouseenter(e => {
        if ($(e.target).hasClass('active')) {
          this.tooltip.active = true;
          this.tooltip.data = this.getFlatById(number);
          this.tooltip.is = flatTooltip;
          $(e.target).addClass('hover');
        }
      });
      $(flat).mouseleave(e => {
        if ($(e.target).hasClass('active')) {
          this.tooltip.active = false;
          $(e.target).removeClass('hover');
        }
      });
    },
    onMapChange() {
      this.initMap();
    },
    initMap() {
      if (window.innerWidth >= 992) {
        let flats = $(this.$refs.map.children).children();
        flats.each((index, flat) => {
          let floorNumber = Number($(flat).data('floor'));
          // let flatNumber = $(flat).data('flat');
          // $(flat).removeClass('active');
          $(flat).addClass('active');
          this.applyFloorEvents(flat, floorNumber);
          // if (floorNumber != null && !isNaN(floorNumber)) {
          //   if (this.filteredFloors.includes(floorNumber)) {
          //     $(flat).addClass('active');
          //   } else {
          //     $(flat).removeClass('active');
          //   }
          //   this.applyFloorEvents(flat, floorNumber);
          // } else if (flatNumber != null) {
          //   if (this.filteredFlatsNumbers.includes(flatNumber)) {
          //     $(flat).addClass('active');
          //   } else {
          //     $(flat).removeClass('active');
          //   }
          //   this.applyFlatEvents(flat, flatNumber);
          // }
        });
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (validateBuilding(to.params)) {
      next();
    } else {
      next('/404');
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (validateBuilding(to.params)) {
      next();
    } else {
      next('/404');
    }
  },
  created: function() {
    window.addEventListener('mouseup', this.onDragEnd);
    window.addEventListener('mousedown', this.onDragging);
    window.addEventListener('touchstart', this.onDragging);
    window.addEventListener('touchend', this.onDragEnd);
    window.addEventListener('resize', this.setAspectRatio);
    this.path = this.$route.path;
    if (window.innerWidth < 992) {
      this.switchTime('dayMobile');
    }
  },
  destroyed: function() {
    window.removeEventListener('mouseup', this.onDragEnd);
    window.removeEventListener('mousedown', this.onDragging);
    window.removeEventListener('touchstart', this.onDragging);
    window.removeEventListener('touchend', this.onDragEnd);
    window.removeEventListener('resize', this.setAspectRatio);
  },
  mounted() {
    if (!this.loaded) {
      this.loadSpriteSpin();
    }
  },
  activated() {
    this.tooltip.active = false;
    let flats = $(this.$refs.map.children).children();
    flats.each((index, flat) => {
      $(flat).removeClass('hover');
    });
  },
};
</script>

<style lang="scss">
.building {
  flex: 1;
}

.spritespin {
  position: relative;
  overflow: hidden;

  min-height: $noTopbarHeight;
}

.spritespin__content {
  position: absolute !important;
  left: 50%;

  transform: translateX(-50%);
  @media (min-width: 1480px) {
    bottom: -20px;
  }
}

.spritespin__map {
  @extend .spritespin__content;
  position: relative;
  pointer-events: none;
  min-width: 100%;

  svg {
    width: 100% !important;
    height: 100% !important;
    transform: none !important;
    position: static !important;

    polygon,
    polyline,
    rect,
    path,
    g {
      fill: $available !important;
      opacity: 0.5 !important;
      fill-opacity: 0 !important;
      visibility: hidden;

      cursor: pointer;
      pointer-events: initial;
      transition: 250ms;
      display: block !important;

      &:hover {
        opacity: 1 !important;
        fill-opacity: 0.9 !important;
      }

      &.active {
        opacity: 0 !important;
        fill-opacity: 0.55 !important;
        visibility: visible;
        pointer-events: all;
        &.hover {
          opacity: 1 !important;
          fill-opacity: 0.5 !important;
        }
      }
    }
  }
}

.spritespin__compass {
  position: absolute;
  top: 0 + $topbarHeight;
  left: 0;
  z-index: 10;
  display: block;
  @media (max-width: 991px) {
    display: none !important;
  }
}

.spritespin__time {
  position: absolute;
  z-index: 10;
  top: 16px + $topbarHeight;
  right: 1rem;

  border: none;

  padding: 1rem;
  background: black;
  color: white;

  cursor: pointer;

  @media screen and (max-width: $sm) {
    top: auto;
    bottom: 1rem;
    padding: 0.7rem;
  }
}

.spritespin__tooltip {
  position: absolute;
  z-index: 100;
  left: 50%;
  top: 20px + $topbarHeight;
  transform: translateX(-50%);

  width: 100%;
  max-width: $lg;
}

.spritespin__button {
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  padding: 24px 16px;

  width: 3%;
  max-width: 50px;
  min-width: 40px;

  background: rgba($primaryColor, 0.8);
  border: none;
  color: white;

  cursor: pointer;

  transition: background 250ms ease;

  @media screen and (max-width: $md) {
    width: 5%;
    padding: 12px 8px;
  }

  @media screen and (max-width: $sm) {
    max-width: 40px;
    min-width: 30px;
    width: 8%;
    padding: 12px 8px;
  }

  img {
    width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  &:focus,
  &:hover {
    outline: none;
    background: rgba($primaryColor, 1);
  }
}

.spritespin-frames {
  width: 100% !important;
  height: 100% !important;
}

.spritespin__button--left {
  @extend .spritespin__button;
  left: 0;
  padding-left: 12px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  @media screen and (max-width: $md) {
    padding-left: 8px;
  }
}

.spritespin__button--right {
  @extend .spritespin__button;
  right: 0;
  padding-right: 12px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  @media screen and (max-width: $md) {
    padding-right: 8px;
  }
}

.spritespin__point {
  position: absolute;
  width: 30px;
  height: 30px;
  z-index: 100;
  visibility: hidden;
  box-shadow: 2px 2px 45px rgba(#000, 0.05);
  opacity: 0;
  pointer-events: all;
  transition: 0.1s;
  &--visible {
    opacity: 1;
    visibility: visible;
    transition: 0.3s;
  }
  &:hover {
    & > .spritespin__point-inner .spritespin__point-label {
      opacity: 1;
      visibility: visible;
      transform: translate(-50%, 0);
    }
    & > .spritespin__point-inner .left {
      transform: translate(0, -50%);
    }
    & > .spritespin__point-inner .right {
      transform: translate(0, -50%);
    }
  }
}

.spritespin__point-inner {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 3px solid $primaryColor;
  background: #fff;
  border-radius: 50%;
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
    transform: scale(1);
    animation: pulse 2s infinite;
    border-radius: 50%;
  }
  & > span {
    color: $primaryColor;
    font-size: 26px;
  }
}

.spritespin__point-label {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%, 15px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  padding: 16px;
  border: 1px solid $lightGray;
  border-radius: 14px;
  min-width: 120px;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  & > span {
    color: #111;
    font-size: 18px;
    user-select: none;
  }
}

.bottom {
  top: 40px;
  bottom: auto;
  transform: translate(-50%, -15px);
}

.left {
  top: 50%;
  bottom: auto;
  left: auto;
  right: 40px;
  transform: translate(15px, -50%);
}

.right {
  top: 50%;
  bottom: auto;
  left: 40px;
  transform: translate(-15px, -50%);
}
</style>
